import Vue from 'vue'
const App = () => import('./App.vue')
import store from "./store"

/* import * as Sentry from "@sentry/vue"
import { Integrations } from "@sentry/tracing" */
import VueCardFormat from 'vue-credit-card-validation'
import HighchartsVue from 'highcharts-vue'
import VueTheMask from 'vue-the-mask'
import FloatingVue from 'floating-vue'
import { isMobile } from '@/common/helpers'
import { directive as ripple } from 'v-ripple-directive'
import '@/designs/new-design/general.css'
import '@/assets/css/flags.css'
import './registerServiceWorker'
import 'floating-vue/dist/style.css'
import 'v-ripple-directive/dist/index.css'
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

Vue.config.productionTip = false

Vue.use(HighchartsVue)
Vue.use(VueCardFormat)
Vue.use(VueTheMask)
Vue.use(FloatingVue)
Vue.use(LottieVuePlayer)

FloatingVue.options.themes.tooltip.delay = { show: 100, hide: 100 }
FloatingVue.options.themes.tooltip.placement = 'bottom-end'
FloatingVue.options.disabled = isMobile()

Vue.directive('ripple', ripple)
Vue.directive('$model', {
  bind: function (el, binding, vnode) {
    el.oninput = () => (vnode.context[binding.expression] = el.value)
  }
})

if (typeof process !== 'undefined' && process.on) {
  process.on('uncaughtException', (err) => {
    console.error('Uncaught Exception:', err)
  })
}

window.addEventListener('unhandledrejection', function (event) {
  console.error('Unhandled Promise Rejection:', event.reason)
})

Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue Error:', err)
  console.warn('In component:', vm)
  console.warn('Info:', info)
}

Vue.config.warnHandler = function (msg, vm, trace) {
  console.warn('Vue warning:', msg)
  console.warn('Trace:', trace)
}

console.log('Version: pro@2026.35.0')

// if (window.app.config.NODE_ENV === 'production') {
//   Sentry.init({
//     Vue,
//     dsn: "https://488c66bbfd442cfcd4c92caddbf32c04@o4510040205688832.ingest.de.sentry.io/4510040312447056",
//     integrations: [
//       new Integrations.BrowserTracing({
//         tracingOrigins: ["localhost", "my-site-url.com", /^\//],
//       }),
//     ],
//     tracesSampleRate: 0.1,
//     release: 'pro@2025.40.0'
//   })
// }

new Vue({
  render: h => h(App),
  store
}).$mount('#app')
